var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.0003 18.3333C14.6027 18.3333 18.3337 14.6023 18.3337 9.99996C18.3337 5.39759 14.6027 1.66663 10.0003 1.66663C5.39795 1.66663 1.66699 5.39759 1.66699 9.99996C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333Z",
    fill: "#ED3241"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 6.66671C10.8337 6.20647 10.4606 5.83337 10.0003 5.83337C9.54009 5.83337 9.16699 6.20647 9.16699 6.66671V11.6667C9.16699 12.1269 9.54009 12.5 10.0003 12.5C10.4606 12.5 10.8337 12.1269 10.8337 11.6667V6.66671Z",
    fill: "#ED3241"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 14.1667C10.8337 13.7065 10.4606 13.3334 10.0003 13.3334C9.54009 13.3334 9.16699 13.7065 9.16699 14.1667C9.16699 14.6269 9.54009 15 10.0003 15C10.4606 15 10.8337 14.6269 10.8337 14.1667Z",
    fill: "#ED3241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.8a1f98744b0206503dacec6167316948.svg";
export { ForwardRef as ReactComponent };